import React, {Component} from "react";
import {translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as settings from "../../../../../constants/settings";
import * as validationHelper from "../../../../../helpers/validationHelper";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as keyWords from "../../../../../constants/keyWords";

import imgMenu from "../../../../../resources/img/svgicons/menu-white.svg";
import imgPrediction from "../../../../../resources/img/svgicons/prediction.svg";
import imgBarcode from "../../../../../resources/img/svgicons/barcode-detail.svg";
import imgWarning from "../../../../../resources/img/svgicons/warning.svg";
import imgCar from "../../../../../resources/img/svgicons/car.svg";
import imgPoint from "../../../../../resources/img/svgicons/point.svg";
import imgCart from "../../../../../resources/img/svgicons/shopping-cart.svg";
import imgPlus from "../../../../../resources/img/svgicons/plus2.svg";
import imgTransparent from "../../../../../resources/img/svgicons/transparent.svg";

import NumericKeyboardInput from "../../../../global/NumericKeyboardInput";
import Button, {BUTTON_EXTRA_LARGE} from "../../../../global/generic/Button";
import Dropdown from "../../../../global/generic/Dropdown";
import Modal from "../../../../global/generic/Modal";

const ROWS_PER_PAGE = 8;

export default class StockModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeWindow: 0,
            // search: "",
            initialPredictionSetDone: this.props.cart.colorantPackages.length !== 0
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            nextProps.cart.colorantPackages.length === 0 &&
            nextProps.colorantPackages.length !== 0 &&
            !prevState.initialPredictionSetDone
        ) {
            nextProps.saveCart({
                ...nextProps.cart,
                colorantPackages: StockModal.calculateColorantPackagesOrderByPrediction(nextProps.colorantPackages)
            });
            return {
                initialPredictionSetDone: true
            };
        }
        return null;
    }

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleOpenAddColorantPackagesClick = () => {
        this.props.openAddColorantPackagesToStockModal();
    };

    handleOpenColorantPackagesConfirmOrderClick = () => {
        this.props.openColorantPackagesConfirmOrderStockModal();
    };

    handleOpenEditColorantPackageInStockClick = (colorantPackageKey) => {
        this.props.openEditColorantPackageInStockModal(colorantPackageKey);
    };

    handleOpenAddColorantPackagesWithSelectedColorantPackageClick = (selectedColorantPackageKey) => {
        this.props.openAddColorantPackagesToStockModal(selectedColorantPackageKey);
    };

    handleChangeActiveWindowForward = () => {
        this.setState({activeWindow: this.state.activeWindow + 1});
    };

    handleChangeActiveWindowBackward = () => {
        this.setState({activeWindow: this.state.activeWindow - 1});
    };

    handleOrderClearAllItemsClick = () => {
        this.props.resetCart();
    };

    handleSelectDatabase = (database) => {
        this.props.setStockDatabaseFilter(database);
        this.setState({
            activeWindow: 0
        });
    };

    static calculateColorantPackagesOrderByPrediction = (colorantPackages) => {
        const colorantPackagesOrder = [];

        colorantPackages.forEach((colorantPackage) => {
            const amountMissing = colorantPackage.prediction - (colorantPackage.ordered + colorantPackage.currentValue);
            if (amountMissing > 0) {
                colorantPackagesOrder.push(
                    modelHelper.buildColorantPackageStock(
                        colorantPackage.key,
                        colorantPackage.item.package.name,
                        colorantPackage.item.colorant.name,
                        colorantPackage.database,
                        amountMissing
                    )
                );
            }
        });

        return colorantPackagesOrder;
    };

    handleOrderSetAmountsByPredictionClick = () => {
        this.props.saveCart({
            ...this.props.cart,
            colorantPackages: StockModal.calculateColorantPackagesOrderByPrediction(this.props.colorantPackages)
        });
    };

    handleSearchInputFocus = () => {
        this.props.setUniversalKeyboardState(true, "stock-search");
    };
    //
    // setSearch = (value) => {
    //     this.setState({
    //         search: value
    //     });
    // };
    //
    // handleSearchChange = (event) => {
    //     this.setSearch(event.target.value);
    // };

    handleSetSort = (sort) => {
        this.props.setStockTableOrderBy(sort);
        this.setState({
            activeWindow: 0
        });
    };

    handleBarcodeClick = (colorantPackage) => {
        this.props.openShowBarcodeModal(colorantPackage.item.colorant.name, colorantPackage.item.package.name);
    };

    handleFocus = (event) => {
        event.target.select();
    };

    handleOrderAmountChange = (colorantPackageKey, orderAmount) => {
        let colorantPackagesOrder = this.props.cart.colorantPackages;

        if (orderAmount === -1) {
            colorantPackagesOrder = colorantPackagesOrder.filter(
                (colorantPackage) => colorantPackage.key !== colorantPackageKey
            );
        } else {
            const colorantPackage = colorantPackagesOrder.find(
                (colorantPackage) => colorantPackage.key === colorantPackageKey
            );
            if (colorantPackage) {
                colorantPackage.value = orderAmount;
            } else {
                const colorantPackageOriginal = this.props.colorantPackages.find(
                    (colorantPackage) => colorantPackage.key === colorantPackageKey
                );
                colorantPackagesOrder.push(
                    modelHelper.buildColorantPackageStock(
                        colorantPackageOriginal.key,
                        colorantPackageOriginal.item.package.name,
                        colorantPackageOriginal.item.colorant.name,
                        colorantPackageOriginal.database,
                        orderAmount
                    )
                );
            }
        }

        this.props.saveCart({
            ...this.props.cart,
            colorantPackages: colorantPackagesOrder
        });
    };

    getWarning = (colorantPackage) => {
        return colorantPackage.currentValue + colorantPackage.ordered < colorantPackage.minValue ? (
            <ReactSVG className="flex flex-align-center width-2_5rem" alt="warning" src={imgWarning} />
        ) : (
            ""
        );
    };

    getOrdered = (colorantPackage) => {
        return colorantPackage.ordered > 0 ? (
            <span className="flex flex-align-center color-warning">
                <ReactSVG
                    className="flex fill-warning flex-align-center width-2_5rem react-svg-icon margin-top-5"
                    alt="car"
                    src={imgCar}
                />
                &nbsp;+{colorantPackage.ordered}
            </span>
        ) : (
            ""
        );
    };

    getColorantPackageRow = (colorantPackage) => {
        return (
            <React.Fragment>
                <div className="flex flex-align-center-vertical flex-gap-0_6rem font-size-3rem">
                    <Button
                        className="svg-only-btn flex-dont-shrink svg-m fill-transparent"
                        size={BUTTON_EXTRA_LARGE}
                        svgBefore={imgTransparent}
                        elementProps={{
                            style: {
                                backgroundColor: colorantPackage.item.colorant.rgb,
                                outline: "2px solid var(--background-color-light)",
                                outlineOffset: "-2px"
                            }
                        }}
                        onClick={() => this.handleOpenEditColorantPackageInStockClick(colorantPackage.key)}
                    />
                    <Button
                        className="svg-only-btn flex-dont-shrink svg-m"
                        size={BUTTON_EXTRA_LARGE}
                        svgBefore={imgBarcode}
                        onClick={() => this.handleBarcodeClick(colorantPackage)}
                    />
                    <div
                        className="color-primary flex-child cursor-pointer flex flex-column"
                        onClick={() => this.handleOpenEditColorantPackageInStockClick(colorantPackage.key)}
                        style={{lineHeight: "1"}}
                    >
                        {colorantPackage.item.colorant.displayName}
                        <br />
                        <span className="font-size-0_5em">{colorantPackage.database}</span>
                    </div>
                </div>
                <div className="flex flex-align-center-vertical flex-gap-0_6rem">
                    <Button
                        className="svg-only-btn flex-dont-shrink svg-m"
                        size={BUTTON_EXTRA_LARGE}
                        svgBefore={imgPlus}
                        onClick={() => {
                            this.handleOpenAddColorantPackagesWithSelectedColorantPackageClick(colorantPackage.key);
                        }}
                    />
                    <span
                        className={
                            colorantPackage.currentValue + colorantPackage.ordered < colorantPackage.minValue
                                ? "color-error"
                                : "color-success"
                        }
                    >
                        {translate("stock.onStock")}
                        :&nbsp;{colorantPackage.currentValue}
                    </span>
                    {this.getOrdered(colorantPackage)}
                </div>
                <div className="flex flex-align-center-vertical flex-gap-5px margin-left-auto">
                    <span className="color-secondary flex fill-secondary">
                        <ReactSVG alt="prediction" className="width-2rem flex margin-right-5" src={imgPrediction} />
                        {translate("stock.prediction")}:
                    </span>
                    {colorantPackage.prediction}

                    <div className="padding-none position-relative fill-secondary">
                        <ReactSVG
                            className="vertical-center flex flex-align-center stock-cart-image react-svg-icon"
                            alt="cart"
                            src={imgCart}
                        />
                        <NumericKeyboardInput
                            type="text"
                            className={
                                "width-100per height-100per text-center primary-select padding-left-35" +
                                ((this.props.cart.colorantPackages.find((cp) => cp.key === colorantPackage.key)
                                    ?.value ?? 0) !== 0
                                    ? " background-color-light-extra"
                                    : "")
                            }
                            style={{width: "100px"}}
                            value={
                                this.props.cart.colorantPackages.find((cp) => cp.key === colorantPackage.key)?.value ??
                                0
                            }
                            onFocus={this.handleFocus}
                            onChange={(event) => {
                                if (validationHelper.isDecimalValueValid(event.target.value)) {
                                    this.handleOrderAmountChange(colorantPackage.key, Number(event.target.value));
                                }
                            }}
                            onBlur={(event) => {
                                let value = Number(event.target.value);

                                if (!isNaN(value) && value !== 0) {
                                    this.handleOrderAmountChange(colorantPackage.key, Number(value));
                                } else {
                                    this.handleOrderAmountChange(colorantPackage.key, -1);
                                }
                            }}
                            setInputState={(value) => {
                                this.handleOrderAmountChange(colorantPackage.key, Number(value));
                            }}
                            disabled={false}
                            extended={false}
                        />
                    </div>
                </div>
                <div className="separator" />
            </React.Fragment>
        );
    };

    getColorantPackagesList = (colorantPackages) => {
        const currentWindow = colorantPackages.slice(
            this.state.activeWindow * ROWS_PER_PAGE,
            this.state.activeWindow * ROWS_PER_PAGE + ROWS_PER_PAGE
        );

        let result = currentWindow.map(this.getColorantPackageRow);
        for (let i = 0; i < 8 - currentWindow.length; i++) {
            result.push(<div className="empty-row" />);
            result.push(<div className="empty-row separator" />);
        }
        return result;
    };

    getBackButton = () => {
        return (
            <Button
                className="full-height-btn padding-15"
                onClick={this.handleChangeActiveWindowBackward}
                label={<span className="glyphicon glyphicon-menu-left" />}
                disabled={this.state.activeWindow === 0}
            />
        );
    };

    getForwardButton = (colorantPackages) => {
        return (
            <Button
                className="full-height-btn padding-15"
                onClick={this.handleChangeActiveWindowForward}
                label={<span className="glyphicon glyphicon-menu-right" />}
                disabled={(this.state.activeWindow + 1) * ROWS_PER_PAGE >= colorantPackages.length}
            />
        );
    };

    getColorantPackageOrderRow = (colorantPackage) => {
        return (
            <div className="flex" key={colorantPackage.key}>
                <div className="col-8 vertical-center padding-none">{colorantPackage.colorant}</div>
                <div className="col-4 vertical-center text-right">{colorantPackage.value}</div>
            </div>
        );
    };

    calculateOrderSum = () => {
        return this.props.cart.colorantPackages.reduce((a, b) => a + b.value, 0);
    };

    getCreateOrderButtonButton = () => {
        return (
            <div className="margin-left-auto flex fill-flex-space">
                <Button
                    className="margin-left-auto svg-m force-show-svg"
                    svgBefore={imgCart}
                    label={translate("stock.createOrder", {sum: this.calculateOrderSum()})}
                    onClick={this.handleOpenColorantPackagesConfirmOrderClick}
                    disabled={this.props.cart.colorantPackages.length === 0}
                />
                <Dropdown
                    name="stock-order-summary"
                    className="force-square"
                    toggleButton={modelHelper.buildDropdownToggleButton(
                        <span className="glyphicon glyphicon-menu-down vertical-center" />,
                        "active force-square flex-align-center full-height-btn"
                    )}
                    contentClassName={"dropdown-menu-right"}
                    content={
                        <React.Fragment>
                            <div
                                className="flex flex-column flex-child fill-flex-space slim-scroll font-size-2rem"
                                style={{maxHeight: "25vh"}}
                            >
                                {this.props.cart.colorantPackages.map(this.getColorantPackageOrderRow)}
                                <div className="flex col-12" style={{borderTop: "3px solid"}}>
                                    <div className="col-8 vertical-center padding-none">{translate("general.sum")}</div>
                                    <div className="col-4 vertical-center text-right">{this.calculateOrderSum()}</div>
                                </div>
                            </div>
                            <Button
                                className="active width-100per margin-top-15"
                                label={translate("stock.clearAllItems")}
                                onClick={this.handleOrderClearAllItemsClick}
                            />
                            <Button
                                className="active width-100per margin-top-15"
                                label={translate("stock.setAmountsByPrediction")}
                                onClick={this.handleOrderSetAmountsByPredictionClick}
                            />
                        </React.Fragment>
                    }
                />
            </div>
        );
    };

    compareAlphabetical = (a, b) => {
        if (a.item.colorant.displayName < b.item.colorant.displayName) {
            return -1;
        }
        if (a.item.colorant.displayName > b.item.colorant.displayName) {
            return 1;
        }
        return 0;
    };

    compareStockLevel = (a, b) => {
        if ((a.currentValue / a.prediction ?? 0) < (b.currentValue / b.prediction ?? 0)) {
            return -1;
        }
        if ((a.currentValue / a.prediction ?? 0) > (b.currentValue / b.prediction ?? 0)) {
            return 1;
        }
        return 0;
    };

    compareOrderNeed = (a, b) => {
        if (a.currentValue + a.ordered - a.prediction < b.currentValue + b.ordered - b.prediction) {
            return -1;
        }
        if (a.currentValue + a.ordered - a.prediction > b.currentValue + b.ordered - b.prediction) {
            return 1;
        }
        return 0;
    };

    getColorantPackagesToShow = () => {
        let colorantPackagesToShow = this.props.colorantPackages;

        // filter by database
        if (this.props.stockDatabaseFilter) {
            colorantPackagesToShow = colorantPackagesToShow.filter(
                (colorantPackage) => colorantPackage.database === this.props.stockDatabaseFilter
            );
        }

        // filter by search
        // if (this.state.search !== "") {
        //     colorantPackagesToShow = colorantPackagesToShow.filter((colorantPackage) =>
        //         colorantPackage.item.colorant.displayName.toLowerCase().includes(this.state.search.toLowerCase())
        //     );
        // }

        // sort
        if (this.props.stockTableOrderBy === settings.STOCK_TABLE_ORDER_BY_COLORANT_NAME) {
            colorantPackagesToShow.sort(this.compareAlphabetical);
        } else if (this.props.stockTableOrderBy === settings.STOCK_TABLE_ORDER_BY_STOCK_LEVEL) {
            colorantPackagesToShow.sort(this.compareStockLevel);
        } else if (this.props.stockTableOrderBy === settings.STOCK_TABLE_ORDER_BY_ORDER_NEED) {
            colorantPackagesToShow.sort(this.compareOrderNeed);
        }

        return colorantPackagesToShow;
    };

    // getSearchBox = () => {
    //     return (
    //         <div
    //             className=""
    //             style={{
    //                 width: "15%",
    //                 marginLeft: "10px",
    //                 position: "relative"
    //             }}
    //         >
    //             <input
    //                 className="height-100per"
    //                 style={{width: "100%", color: "black"}}
    //                 id="stock-search"
    //                 type="text"
    //                 value={this.state.search}
    //                 onChange={this.handleSearchChange}
    //                 onFocus={this.handleSearchInputFocus}
    //             />
    //             <div
    //                 style={{
    //                     maxHeight: "100%",
    //                     width: "30px",
    //                     position: "absolute",
    //                     right: "5px",
    //                     top: "10px",
    //                     pointerEvents: "none"
    //                 }}
    //             >
    //                 <ReactSVG alt="search" src={imgSearch} />
    //             </div>
    //
    //             {/*<div style={{position: "fixed", bottom: "0px", left: "0px", width: "90vw", zIndex: "5000"}}>
    //                             <VirtualKeyboard element={"#stock-search"} setKeyboardInput={this.setSearch} />
    //                         </div>*/}
    //         </div>
    //     );
    // };

    getSortOption = (sort) => {
        return (
            <Button
                className="margin-bottom-10 width-100per active force-show-svg svg-s"
                key={"sort-" + sort}
                onClick={() => this.handleSetSort(sort)}
                svgBefore={this.props.stockTableOrderBy === sort ? imgPoint : undefined}
                label={
                    <React.Fragment>
                        {sort === settings.STOCK_TABLE_ORDER_BY_COLORANT_NAME && translate("stock.sortByColorantName")}
                        {sort === settings.STOCK_TABLE_ORDER_BY_ORDER_NEED && translate("stock.sortByOrderNeed")}
                        {sort === settings.STOCK_TABLE_ORDER_BY_STOCK_LEVEL && translate("stock.sortByStockLevel")}
                    </React.Fragment>
                }
            />
        );
    };

    getSortOptions = () => {
        return [
            this.getSortOption(settings.STOCK_TABLE_ORDER_BY_COLORANT_NAME),
            this.getSortOption(settings.STOCK_TABLE_ORDER_BY_ORDER_NEED),
            this.getSortOption(settings.STOCK_TABLE_ORDER_BY_STOCK_LEVEL)
        ];
    };

    getDatabaseOption = (database) => {
        return (
            <Button
                className="margin-bottom-10 width-100per active"
                key={"database-" + database}
                label={database === keyWords.KEYWORD_ALL ? translate("stock.allDatabases") : database}
                onClick={() => this.handleSelectDatabase(database === keyWords.KEYWORD_ALL ? null : database)}
            />
        );
    };

    getDatabaseOptions = () => {
        return [
            this.getDatabaseOption(keyWords.KEYWORD_ALL),
            ...this.props.databases.map((database) => this.getDatabaseOption(database))
        ];
    };

    getDatabasesDropdown = () => {
        if (this.props.databases.length < 2) {
            return null;
        }

        return (
            <Dropdown
                name="stock-database"
                toggleButton={modelHelper.buildDropdownToggleButton(
                    this.props.stockDatabaseFilter ?? translate("stock.allDatabases"),
                    "full-height-btn flex-child"
                )}
                content={this.getDatabaseOptions()}
            />
        );
    };

    getSubHeader = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    label={translate("stock.addPackagesToStock")}
                    onClick={this.handleOpenAddColorantPackagesClick}
                />
                <Dropdown
                    name="stock-sort"
                    toggleButton={modelHelper.buildDropdownToggleButton("", "svg-only-btn flex-child", imgMenu)}
                    content={this.getSortOptions()}
                    className="flex-child"
                />
                {this.getDatabasesDropdown()}
                {this.getCreateOrderButtonButton()}
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        const colorantPackagesToShow = this.getColorantPackagesToShow();
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("stock.colorantsStockInventory"))}
                subHeader={this.getSubHeader()}
                content={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getBackButton()}
                        <div className="fill-flex-space padding-5 stock-inventory">
                            {this.getColorantPackagesList(colorantPackagesToShow)}
                        </div>
                        {this.getForwardButton(colorantPackagesToShow)}
                    </React.Fragment>
                )}
                styles={{height: "80%", minWidth: "80%", maxWidth: "95%", maxHeight: "95%"}}
            />
        );
    }
}
